export default function Card({ title, description, href, icon }) {
  const Icon = icon;

  return (
    <a
      href={href}
      className="no-underline bg-white shadow-elevation rounded-lg py-5 px-6 text-haiti transition-colors hover:bg-faded-cornflower"
      target="_blank"
      rel="noopener noreferrer"
    >
      <div className="flex items-center">
        <span className="flex items-center justify-center bg-faded-cornflower text-cornflower rounded w-10 h-10 mr-2">
          <Icon className="w-5 h-5" />
        </span>

        <span className="text-haiti font-bold text-xl">{title}</span>
      </div>

      <p className="text-light-haiti text-base mt-4">{description}</p>
    </a>
  );
}
